import { createAsyncThunk } from "@reduxjs/toolkit"
import { API_BASE_URL, API_KEY_ID, API_KEY_SECRET } from "../../constant"
import axios from "axios"

/**
 * CHECKOUT
 */
export const storeOrder = createAsyncThunk('user/storeOrder', async (data, { rejectWithValue, getState }) => {
    try {
        console.log("action data:", JSON.stringify(data, null, 2))
        const { token } = getState().user;
        if (!token) {
            throw new Error("User token not found.");
        }

        const res = await axios.post(`${API_BASE_URL}/store-order`, data, {
            headers: {
                'X-API-KEY-ID': API_KEY_ID,
                'X-API-KEY-SECRET': API_KEY_SECRET,
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });

        console.log("Store order response:", JSON.stringify(res.data, null, 2));
        return res.data;
    } catch (error) {
        console.error("Store order error:", error.message);
        return rejectWithValue(error.response?.data || error.message);
    }
});